var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderDotGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 711,
    height: 639,
    viewBox: "0 0 711 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -148,
    width: 712,
    height: 788
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682.064 185.688L711.025 160.504L709.766 -148L552.366 -148L475.555 -74.9661L449.112 -74.9661L306.822 74.8787L279.12 74.8787L146.904 203.317L146.904 364.495L128.016 398.493L0.836365 639L128.016 639L150.681 588.632L150.681 387.16L155.718 356.94L155.718 311.608L510.813 311.608L510.813 286.424L558.662 286.424L558.662 248.648L581.328 208.354L586.365 185.688L682.064 185.688Z",
    fill: "#FFFFFF80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 595.788 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 707.897 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 567.759 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 679.87 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 651.843 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 623.814 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 595.788 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 707.897 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 567.759 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 679.87 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 651.843 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 623.814 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 595.788 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 707.897 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 567.759 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 679.87 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 651.843 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 623.814 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 595.788 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 707.897 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 567.759 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 679.87 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 651.843 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 623.814 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 20.4086,
    r: 2.80274,
    transform: "rotate(-180 595.788 20.4086)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 707.897 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 20.4086,
    r: 2.80274,
    transform: "rotate(-180 567.759 20.4086)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 679.87 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 651.843 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 623.814 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 343.055 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 202.918 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 315.027 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 174.891 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 287 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.972,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 258.972 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 230.944 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 343.055 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 202.918 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 315.027 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 174.891 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 287 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.972,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 258.972 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 76.4636,
    r: 2.80274,
    transform: "rotate(-180 230.944 76.4636)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 343.055 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 202.918 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 315.027 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 174.891 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 287 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.972,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 258.972 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 230.944 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 343.055 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 202.918 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 315.027 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 174.891 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 287 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.972,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 258.972 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 48.4359,
    r: 2.80274,
    transform: "rotate(-180 230.944 48.4359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 20.4095,
    r: 2.80274,
    transform: "rotate(-180 343.055 20.4095)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 20.4083,
    r: 2.80274,
    transform: "rotate(-180 202.918 20.4083)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 20.4095,
    r: 2.80274,
    transform: "rotate(-180 315.027 20.4095)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 20.4083,
    r: 2.80274,
    transform: "rotate(-180 174.891 20.4083)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 20.4095,
    r: 2.80274,
    transform: "rotate(-180 287 20.4095)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.972,
    cy: 20.4095,
    r: 2.80274,
    transform: "rotate(-180 258.972 20.4095)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 20.4095,
    r: 2.80274,
    transform: "rotate(-180 230.944 20.4095)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.489,
    cy: 132.518,
    r: 2.80274,
    transform: "rotate(-180 539.489 132.518)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 399.353 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 511.464 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 371.325 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 483.435 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 455.407 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.379,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 427.379 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 539.49 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 399.353 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 511.464 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 371.325 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 483.435 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 455.407 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 76.4633,
    r: 2.80274,
    transform: "rotate(-180 427.381 76.4633)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 539.49 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 399.353 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 511.464 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 371.325 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 483.435 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 455.407 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 104.491,
    r: 2.80274,
    transform: "rotate(-180 427.381 104.491)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 539.49 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 399.353 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 511.464 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 371.325 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 483.435 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 455.407 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.379,
    cy: 48.4356,
    r: 2.80274,
    transform: "rotate(-180 427.379 48.4356)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 539.49 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 20.4086,
    r: 2.80274,
    transform: "rotate(-180 399.353 20.4086)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 511.464 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 20.4086,
    r: 2.80274,
    transform: "rotate(-180 371.325 20.4086)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 483.435 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 455.407 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 20.4099,
    r: 2.80274,
    transform: "rotate(-180 427.381 20.4099)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 146.618 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 132.518,
    r: 2.80274,
    transform: "rotate(-180 6.48144 132.518)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 118.591 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 90.563 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 132.519,
    r: 2.80274,
    transform: "rotate(-180 62.5354 132.519)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 132.518,
    r: 2.80274,
    transform: "rotate(-180 34.509 132.518)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 76.4637,
    r: 2.80274,
    transform: "rotate(-180 146.618 76.4637)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 76.4631,
    r: 2.80274,
    transform: "rotate(-180 6.48144 76.4631)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 76.4637,
    r: 2.80274,
    transform: "rotate(-180 118.591 76.4637)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 76.4637,
    r: 2.80274,
    transform: "rotate(-180 90.563 76.4637)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 76.4631,
    r: 2.80274,
    transform: "rotate(-180 62.5366 76.4631)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 76.4631,
    r: 2.80274,
    transform: "rotate(-180 34.509 76.4631)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 104.49,
    r: 2.80274,
    transform: "rotate(-180 146.618 104.49)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 104.489,
    r: 2.80274,
    transform: "rotate(-180 6.48144 104.489)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 104.49,
    r: 2.80274,
    transform: "rotate(-180 118.591 104.49)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 104.49,
    r: 2.80274,
    transform: "rotate(-180 90.563 104.49)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 104.49,
    r: 2.80274,
    transform: "rotate(-180 62.5354 104.49)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5078,
    cy: 104.49,
    r: 2.80274,
    transform: "rotate(-180 34.5078 104.49)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 48.436,
    r: 2.80274,
    transform: "rotate(-180 146.618 48.436)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 48.436,
    r: 2.80274,
    transform: "rotate(-180 6.48144 48.436)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 48.436,
    r: 2.80274,
    transform: "rotate(-180 118.591 48.436)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 48.436,
    r: 2.80274,
    transform: "rotate(-180 90.563 48.436)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 48.436,
    r: 2.80274,
    transform: "rotate(-180 62.5366 48.436)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 48.436,
    r: 2.80274,
    transform: "rotate(-180 34.509 48.436)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 20.4084,
    r: 2.80274,
    transform: "rotate(-180 146.618 20.4084)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 20.4084,
    r: 2.80274,
    transform: "rotate(-180 6.48144 20.4084)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 20.4084,
    r: 2.80274,
    transform: "rotate(-180 118.591 20.4084)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 20.4084,
    r: 2.80274,
    transform: "rotate(-180 90.563 20.4084)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 20.4084,
    r: 2.80274,
    transform: "rotate(-180 62.5354 20.4084)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 20.4084,
    r: 2.80274,
    transform: "rotate(-180 34.509 20.4084)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 595.788 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 707.897 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 567.759 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 679.87 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 651.843 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 623.814 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 595.788 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 707.897 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 567.759 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 679.87 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 651.843 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 623.814 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 595.788 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 707.897 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 567.759 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 679.87 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 651.843 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 623.814 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 595.788 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 707.897 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 567.759 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 679.87 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 651.843 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 623.814 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 595.788 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 595.788 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 707.897 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 707.897 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 567.759 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 567.759 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 679.87 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 679.87 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 651.843 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 651.843 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 623.814 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 623.814 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 595.788 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 707.897 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 567.759 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 679.87 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 651.843 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 623.814 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 525.387,
    r: 2.80274,
    transform: "rotate(-180 343.055 525.387)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 202.918 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 315.027 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 174.891 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 287 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 258.973 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 230.945 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 343.055 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 202.918 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 315.027 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 174.891 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 287 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 258.973 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 230.945 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 343.055 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 202.918 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 315.027 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 174.891 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 287 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 258.973 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 230.945 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 343.055 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 202.918 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 315.027 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 174.891 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 287 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 258.973 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 230.945 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 343.055 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 343.055 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 202.918 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 202.918 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 315.027 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 315.027 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 174.891 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 174.891 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 287 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 287 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 258.973 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 258.973 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.946,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 230.946 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.946,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 230.946 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 343.055 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 202.918 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 315.027 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 174.891 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 287 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 258.973 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 230.945 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.492,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 539.492 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 399.354 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 511.463 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 371.326 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 483.435 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 455.407 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 427.381 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 539.49 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 399.354 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 511.463 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 371.326 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 483.435 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 455.407 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 469.333,
    r: 2.80274,
    transform: "rotate(-180 427.381 469.333)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 539.49 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 399.354 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 511.463 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 371.326 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 483.435 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 455.407 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 497.359,
    r: 2.80274,
    transform: "rotate(-180 427.381 497.359)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 539.49 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 399.354 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 511.463 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 371.326 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 483.435 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 455.407 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 441.305,
    r: 2.80274,
    transform: "rotate(-180 427.381 441.305)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 539.49 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 539.49 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 399.354 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 399.354 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 511.463 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 511.463 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 371.326 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 371.326 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 483.435 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 483.435 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 455.407 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 455.407 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 427.381 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 427.381 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 539.49 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 399.354 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 511.463 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 371.326 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 483.435 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 455.407 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 427.381 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 525.387,
    r: 2.80274,
    transform: "rotate(-180 146.618 525.387)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 525.389,
    r: 2.80274,
    transform: "rotate(-180 6.48144 525.389)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 118.591 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 90.563 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 525.388,
    r: 2.80274,
    transform: "rotate(-180 62.5354 525.388)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 525.389,
    r: 2.80274,
    transform: "rotate(-180 34.509 525.389)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 469.334,
    r: 2.80274,
    transform: "rotate(-180 146.618 469.334)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 469.334,
    r: 2.80274,
    transform: "rotate(-180 6.48144 469.334)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 469.334,
    r: 2.80274,
    transform: "rotate(-180 118.591 469.334)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 469.334,
    r: 2.80274,
    transform: "rotate(-180 90.563 469.334)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 469.334,
    r: 2.80274,
    transform: "rotate(-180 62.5366 469.334)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 469.334,
    r: 2.80274,
    transform: "rotate(-180 34.509 469.334)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 146.618 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 6.48144 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 118.591 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 90.563 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 62.5354 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5078,
    cy: 497.36,
    r: 2.80274,
    transform: "rotate(-180 34.5078 497.36)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 441.306,
    r: 2.80274,
    transform: "rotate(-180 146.618 441.306)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 441.306,
    r: 2.80274,
    transform: "rotate(-180 6.48144 441.306)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 441.306,
    r: 2.80274,
    transform: "rotate(-180 118.591 441.306)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 441.306,
    r: 2.80274,
    transform: "rotate(-180 90.563 441.306)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 441.306,
    r: 2.80274,
    transform: "rotate(-180 62.5366 441.306)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 441.306,
    r: 2.80274,
    transform: "rotate(-180 34.509 441.306)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 146.618 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 146.618 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 385.252,
    r: 2.80274,
    transform: "rotate(-180 6.48144 385.252)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 357.226,
    r: 2.80274,
    transform: "rotate(-180 6.48144 357.226)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 118.591 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 118.591 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 90.563 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 357.225,
    r: 2.80274,
    transform: "rotate(-180 90.563 357.225)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 62.5354 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 357.226,
    r: 2.80274,
    transform: "rotate(-180 62.5366 357.226)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5078,
    cy: 385.251,
    r: 2.80274,
    transform: "rotate(-180 34.5078 385.251)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 357.226,
    r: 2.80274,
    transform: "rotate(-180 34.509 357.226)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 146.618 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 6.48144 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 118.591 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 90.563 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 62.5354 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 413.278,
    r: 2.80274,
    transform: "rotate(-180 34.509 413.278)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 595.788 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 707.897 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 567.759 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 679.87 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 651.843 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 623.814 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 595.788 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 707.897 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 567.759 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 679.87 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 651.843 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 623.814 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 595.788 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 707.897 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 567.759 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 679.87 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 651.843 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 623.814 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 595.788 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 707.897 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 567.759 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 679.87 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 651.843 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 623.814 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 595.788 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 595.788 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 707.897 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 707.897 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 567.759 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 567.759 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 679.87 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 679.87 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 651.843 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 651.843 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 623.814 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 623.814 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 595.788 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.897,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 707.897 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.759,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 567.759 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.87,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 679.87 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 651.843 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 623.814 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 343.053 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 202.916 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 315.026 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 174.89 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 286.998 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 258.97 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.943,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 230.943 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 343.053 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 202.916 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 315.026 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 174.89 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 286.998 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 258.97 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.943,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 230.943 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 343.053 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 202.916 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 315.026 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 174.89 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 286.998 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 258.97 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.943,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 230.943 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 343.053 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 202.916 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 315.026 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 174.89 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 286.998 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 258.97 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.943,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 230.943 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 343.053 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 343.053 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 202.916 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 202.916 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 315.026 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 315.026 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 174.89 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 174.89 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 286.998 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 286.998 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 258.97 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 258.97 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 230.944 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.944,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 230.944 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.053,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 343.053 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.916,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 202.916 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.026,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 315.026 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.89,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 174.89 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.998,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 286.998 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.97,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 258.97 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.943,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 230.943 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.492,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 539.492 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 399.354 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 511.463 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 371.326 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 483.435 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 455.407 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 328.954,
    r: 2.80274,
    transform: "rotate(-180 427.381 328.954)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 539.49 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 399.354 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 511.463 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 371.326 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 483.435 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 455.407 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 272.899,
    r: 2.80274,
    transform: "rotate(-180 427.381 272.899)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 539.49 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 399.354 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 511.463 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 371.326 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 483.435 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 455.407 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 300.927,
    r: 2.80274,
    transform: "rotate(-180 427.381 300.927)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 539.49 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 399.354 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 511.463 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 371.326 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 483.435 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 455.407 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 244.871,
    r: 2.80274,
    transform: "rotate(-180 427.381 244.871)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 539.49 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 539.49 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 399.354 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 399.354 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 511.463 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 511.463 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 371.326 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 371.326 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 483.435 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 483.435 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 455.407 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 455.407 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 188.817,
    r: 2.80274,
    transform: "rotate(-180 427.381 188.817)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 160.79,
    r: 2.80274,
    transform: "rotate(-180 427.381 160.79)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 539.49 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.354,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 399.354 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.463,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 511.463 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.326,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 371.326 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 483.435 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 455.407 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.381,
    cy: 216.844,
    r: 2.80274,
    transform: "rotate(-180 427.381 216.844)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 146.619 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 6.48266 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 118.592 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 90.5637 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5374,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 62.5374 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5105,
    cy: 328.953,
    r: 2.80274,
    transform: "rotate(-180 34.5105 328.953)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 146.619 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 6.48266 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 118.592 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 90.5637 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5369,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 62.5369 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5105,
    cy: 272.898,
    r: 2.80274,
    transform: "rotate(-180 34.5105 272.898)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 146.619 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 6.48266 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 118.592 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 300.926,
    r: 2.80274,
    transform: "rotate(-180 90.5637 300.926)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5374,
    cy: 300.925,
    r: 2.80274,
    transform: "rotate(-180 62.5374 300.925)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5105,
    cy: 300.925,
    r: 2.80274,
    transform: "rotate(-180 34.5105 300.925)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 244.87,
    r: 2.80274,
    transform: "rotate(-180 146.619 244.87)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 244.87,
    r: 2.80274,
    transform: "rotate(-180 6.48266 244.87)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 244.87,
    r: 2.80274,
    transform: "rotate(-180 118.592 244.87)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 244.87,
    r: 2.80274,
    transform: "rotate(-180 90.5637 244.87)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5369,
    cy: 244.87,
    r: 2.80274,
    transform: "rotate(-180 62.5369 244.87)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 244.87,
    r: 2.80274,
    transform: "rotate(-180 34.509 244.87)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 188.816,
    r: 2.80274,
    transform: "rotate(-180 146.619 188.816)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 146.619 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 188.816,
    r: 2.80274,
    transform: "rotate(-180 6.48266 188.816)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 160.788,
    r: 2.80274,
    transform: "rotate(-180 6.48266 160.788)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 188.816,
    r: 2.80274,
    transform: "rotate(-180 118.592 188.816)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 118.592 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 188.816,
    r: 2.80274,
    transform: "rotate(-180 90.5637 188.816)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 90.5637 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5374,
    cy: 188.816,
    r: 2.80274,
    transform: "rotate(-180 62.5374 188.816)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5369,
    cy: 160.789,
    r: 2.80274,
    transform: "rotate(-180 62.5369 160.789)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5105,
    cy: 188.816,
    r: 2.80274,
    transform: "rotate(-180 34.5105 188.816)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5105,
    cy: 160.788,
    r: 2.80274,
    transform: "rotate(-180 34.5105 160.788)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.619,
    cy: 216.843,
    r: 2.80274,
    transform: "rotate(-180 146.619 216.843)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48266,
    cy: 216.843,
    r: 2.80274,
    transform: "rotate(-180 6.48266 216.843)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.592,
    cy: 216.843,
    r: 2.80274,
    transform: "rotate(-180 118.592 216.843)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5637,
    cy: 216.843,
    r: 2.80274,
    transform: "rotate(-180 90.5637 216.843)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5374,
    cy: 216.843,
    r: 2.80274,
    transform: "rotate(-180 62.5374 216.843)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5105,
    cy: 216.843,
    r: 2.80274,
    transform: "rotate(-180 34.5105 216.843)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 595.788 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.898,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 707.898 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.76,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 567.76 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.869,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 679.869 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 651.843 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 623.814 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 581.688,
    r: 2.80274,
    transform: "rotate(-180 595.788 581.688)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 553.66,
    r: 2.80274,
    transform: "rotate(-180 595.788 553.66)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.898,
    cy: 581.688,
    r: 2.80274,
    transform: "rotate(-180 707.898 581.688)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.898,
    cy: 553.66,
    r: 2.80274,
    transform: "rotate(-180 707.898 553.66)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.76,
    cy: 581.688,
    r: 2.80274,
    transform: "rotate(-180 567.76 581.688)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.76,
    cy: 553.66,
    r: 2.80274,
    transform: "rotate(-180 567.76 553.66)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.869,
    cy: 581.688,
    r: 2.80274,
    transform: "rotate(-180 679.869 581.688)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.869,
    cy: 553.66,
    r: 2.80274,
    transform: "rotate(-180 679.869 553.66)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 581.688,
    r: 2.80274,
    transform: "rotate(-180 651.843 581.688)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 553.66,
    r: 2.80274,
    transform: "rotate(-180 651.843 553.66)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 581.688,
    r: 2.80274,
    transform: "rotate(-180 623.814 581.688)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 553.66,
    r: 2.80274,
    transform: "rotate(-180 623.814 553.66)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.788,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 595.788 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.898,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 707.898 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.76,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 567.76 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.869,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 679.869 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.843,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 651.843 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.814,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 623.814 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 343.055 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 202.918 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 315.027 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 174.891 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 287 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 258.973 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 230.945 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 343.055 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 343.055 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 202.918 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 202.918 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 315.027 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 315.027 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 174.891 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 174.891 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 287 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 287 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 258.973 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 258.973 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.946,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 230.946 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.946,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 230.946 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.055,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 343.055 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.918,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 202.918 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.027,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 315.027 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.891,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 174.891 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 287 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.973,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 258.973 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.945,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 230.945 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 539.49 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 399.353 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 511.464 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 371.325 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 483.435 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 455.407 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.379,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 427.379 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 539.49 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 539.49 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 399.353 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 399.353 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 511.464 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 511.464 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 371.325 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 371.325 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 483.435 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 483.435 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 455.407 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 455.407 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.379,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 427.379 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.379,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 427.379 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.49,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 539.49 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.353,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 399.353 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.464,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 511.464 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.325,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 371.325 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.435,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 483.435 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.407,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 455.407 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.379,
    cy: 609.715,
    r: 2.80274,
    transform: "rotate(-180 427.379 609.715)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 146.618 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 6.48144 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 118.591 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 90.563 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 62.5366 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 637.742,
    r: 2.80274,
    transform: "rotate(-180 34.509 637.742)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 146.618 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 146.618 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 6.48144 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 6.48144 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 118.591 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 118.591 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 90.563 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 90.563 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 62.5354 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5366,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 62.5366 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5078,
    cy: 581.687,
    r: 2.80274,
    transform: "rotate(-180 34.5078 581.687)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 553.661,
    r: 2.80274,
    transform: "rotate(-180 34.509 553.661)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.618,
    cy: 609.714,
    r: 2.80274,
    transform: "rotate(-180 146.618 609.714)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48144,
    cy: 609.714,
    r: 2.80274,
    transform: "rotate(-180 6.48144 609.714)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.591,
    cy: 609.714,
    r: 2.80274,
    transform: "rotate(-180 118.591 609.714)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.563,
    cy: 609.714,
    r: 2.80274,
    transform: "rotate(-180 90.563 609.714)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5354,
    cy: 609.714,
    r: 2.80274,
    transform: "rotate(-180 62.5354 609.714)",
    fill: "#FFFFFF80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 609.714,
    r: 2.80274,
    transform: "rotate(-180 34.509 609.714)",
    fill: "#FFFFFF80"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDotGrid);
export default __webpack_public_path__ + "static/media/headerDotGrid.4c387b39677309a2cb463a3ec646488f.svg";
export { ForwardRef as ReactComponent };